import React from 'react'
import State from '../../features/admin/Region/State'
const StatePage = () => {
  return <State />
}

export default StatePage